import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'save-license',
    initialState: {
        isInserted: '',
        statusAction: 'READY',
    },
    actions: ['SAVE_LICENSE'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.SAVE_LICENSE_SUCCESS:
                return {
                    ...state,
                    isInserted: action.payload.isInserted
                };
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        saveLicenseRequest: ( new_license ) => ({
            type: types.SAVE_LICENSE_REQUEST,
            payload: { new_license },
        }),
        saveLicenseSuccess: ({ isInserted }) => ({
            type: types.SAVE_LICENSE_SUCCESS,
            payload: { isInserted },
        }),
        saveLicenseFailed: error => ({ type: types.SAVE_LICENSE_FAILED, error: true, payload: { error } }),
    }),
});
